// extracted by mini-css-extract-plugin
module.exports = {"padding":"SubHeadline-module--padding--2yQYm"};